
import UserOptions from "./UserOptions";
import { Dropdown } from "react-bootstrap";
import Storage from "@/app/core/util/Storage";
import React, { useEffect, useState } from "react";
import CheckMobile from "@/app/core/util/Screen";
import Logo from "./Logo";
import { Menu, MenuAdmin, MenuCommercial, MenuUser } from "@/app/core/config/menu";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";

export default function Header() {
  const userData = Storage.getUserData();
  let screenWidth = CheckMobile();
  const whatsLink = "https://api.whatsapp.com/send?phone=5521971160297&text=%2APrezado%20Consumidor%2C%20preencha%20os%20dados%20abaixo%20para%20Reclamar%2A%20%F0%9F%93%A2%20%0ASeu%20nome%3A%0ASua%20Cidade%3A%0AEmpresa%20Reclamada%3A%0ASua%20Reclama%C3%A7%C3%A3o%F0%9F%93%A3%3A";

  useEffect(() => {
  }, [userData]);

  function leave() {
    if (window.confirm("Tem certeza que deseja sair?")) {
      AccountController.Logout();
      localStorage.removeItem("user_data");
      window.location.reload();
    }
  }

  function loadMenu(){
    return <div>

    {userData && userData.level === UserHelper.UserLevel.User ?
      <div>
        {MenuUser.map(item => (
            <a className="text-left btn btn-block mr-1 ml-1 btn-dual border-top text-dark font-w500" href={item.routerLink}>
              <i className={item.icon} /> {item.name}
            </a>
        ))}
      </div>
      : userData && userData.level === UserHelper.UserLevel.Commercial ?
        <div>
          {MenuCommercial.map(item => (
              <a className="text-left btn btn-block mr-1 ml-1 btn-dual border-top text-dark font-w500" href={item.routerLink}>
                <i className={item.icon} /> {item.name}
              </a>
          ))}
        </div>
        : userData && userData.level === UserHelper.UserLevel.Administrator ?
        <div>
        {MenuAdmin.map(item => (
            <div>
              <a key={item.id} className="text-left btn btn-block mr-1 ml-1 btn-dual border-top text-dark font-w500" href={item.routerLink}>{item.icon.length > 0 ? <i className={item.icon} /> : ""} {item.name}</a>
            </div>
        ))}
      </div>
        : userData !== null ? 
        <div>
          {MenuUser.map(item => (
              <div>
                <a key={item.id} className="text-left btn btn-block mr-1 ml-1 btn-dual border-top text-dark font-w500" href={item.routerLink}>{item.icon.length > 0 ? <i className={item.icon} /> : ""} {item.name}</a>
              </div>
          ))}
          
          </div>
          :
          <div>
          <a className="text-left btn btn-dual btn-block border-top font-w500 text-dark" href={"#/quem-somos"}>Quem somos</a>
          <a className="text-left btn btn-dual btn-block border-top font-w500 text-dark" href={"#/contato"}>Contato</a>
          <a className="text-left btn btn-dual btn-block border-top font-w500 text-dark" href={"#/auth"}>Acessar Conta</a>
          </div>
        
        }
        {/* </div> */}
    </div>
  }

  function loadButton() {
    if (userData) {
      return (
        <div className="dropdown d-inline-block">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic" className="btn" variant="light">
              Minha conta
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {loadMenu()}
              <Dropdown.Item>
                {userData !== null ? 
                <a className="btn mr-1 ml-1 btn-white text-dark font-w500" onClick={()=> leave()}><i className={"si si-logout"} /> Sair</a>
                : ""}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    } else {
      if(!userData)
      return <a
        className="btn btn-warning text-dark"
        alt="Sair"
        href="#/auth"> Acessar conta
      </a>

    }
  }

  return (
    <header id="page-header" className="bg-black">
      {screenWidth == false ?
        <div className="content-header">
          <div>
            <Logo style={{ height: 38 }} />
          </div>
          <div>

          </div>
          <div>
            {Menu.map(item => (
              <a className="btn btn-link text-white ml-1 mr-1" href={item.routerLink}>
                {item.name}
              </a>
            ))}
            {loadButton()}

          </div>
        </div>
        :
        <div className="row p-2">
          <div className="col-6 text-center title py-2">
           <Logo style={{ height: 28 }} />
          </div>
          <div className="col-6 text-right title py-2">
            <Dropdown>
              <Dropdown.Toggle>
                <i className="fa fa-fw fa-bars"/>
              </Dropdown.Toggle>
              <Dropdown.Menu className="text-left">
                <a className="btn btn-block btn-success text-white" href={whatsLink}>Reclamar pelo <i className="fab fa-whatsapp"/></a>
                {loadMenu()}
                {userData !== null ? 
                <a className="btn mr-1 ml-1 btn-white text-dark font-w500" onClick={()=> leave()}><i className={"si si-logout"} /> Sair</a>
                : 
                <a className="text-left btn btn-dual btn-block border-top font-w500 text-dark" href={"#/auth"}>Acessar Conta</a>}
              </Dropdown.Menu>
            </Dropdown>

          </div>
        </div>
      }

      <div id="page-header-loader" className="overlay-header bg-primary-darker">
        <div className="content-header">
          <div className="w-100 text-center">
            <i className="fa fa-fw fa-2x fa-sun fa-spin text-white" />
          </div>
        </div>
      </div>

    </header>
  );
}
